/**
 * 预售计划单 - 单对象 - 主子表表单联动
 * 1. 主-库存同步规则==实际库存：
 *  1.1. 不展示:子-表单part-(计划)预售数量，
 *  1.2. 不展示:子表part-(计划)预售数量、剩余量
 * 2. 注意 详情初始化/刷新 时 的处理
 */

export default {
  mounted() {
    window.addEventListener("notificationOfMain", ({ detail }) => {
      this.subLinkChange01(detail)
    }, false);

  },
  updated() {
    if (vm.$route.params.tableName == 'SG_C_PRE_SALE_PLAN') {
      this.initSubLinkChange01()
    }
  },
  methods: {
    subLinkChange01(_detail) {
      if (vm.$route.params.tableName == 'SG_C_PRE_SALE_PLAN' && !vm.$route.fullPath.includes("/SYSTEM/TABLE/")) {
        let detail = _detail
        if (!detail) { // 详情初始化/刷新
          const page = vm.$store.state[R3.getModuleName()]
          const childs = page.copyDataForReadOnly.addcolums[0].childs
          detail = {
            INVENTORY_SYNC_RULE: Number(childs.find(i => i.colname == "INVENTORY_SYNC_RULE").valuedata || '')
          }
        }
        if (detail.hasOwnProperty('INVENTORY_SYNC_RULE') || (detail.item && detail.item.colname == "INVENTORY_SYNC_RULE")) {
          if (detail.item && detail.item.colname == "INVENTORY_SYNC_RULE") {
            detail = {
              INVENTORY_SYNC_RULE: Number(detail.item.currentValue)
            }
          }
          console.log('预售计划单-主子表联动::', detail);
          const page = vm.$store.state[R3.getModuleName()]
          const nowTabForm = _.cloneDeep(page.tabPanels[page.tabCurrentIndex].componentAttribute.formData.data.inpubobj)
          const nowTabTable= _.cloneDeep(page.tabPanels[page.tabCurrentIndex].componentAttribute.tableData.data)
          let newData = {
            tabIndex: page.tabCurrentIndex,
            inpubobj: nowTabForm
          }
          try {
            switch (detail.INVENTORY_SYNC_RULE) {
              case 2: // "实际库存（配销仓库存）"
                nowTabForm.forEach((it, dex) => {
                  if (["PLAN_COUNT"].includes(it.colname)) {
                    it._show = false
                  }
                });
                newData = {
                  tabIndex: page.tabCurrentIndex,
                  inpubobj: nowTabForm
                }
                nowTabTable.tabth.forEach((it, dex) => {
                  if (["PLAN_COUNT", "RESIDUE_COUNT"].includes(it.colname)) {
                    it.hide = true
                  }
                });
                break;
              default:
                nowTabForm.forEach((it, dex) => {
                  it._show = true
                });
                if (nowTabTable && nowTabTable.tabth) {
                  nowTabTable.tabth.forEach((it, dex) => {
                    it.hide = false
                  });
                }
                break;
            }
            $store.commit(`${R3.getModuleName()}/updateFormDataForRefTable`, newData) // 更新子表-表单
            $store.commit(`${R3.getModuleName()}/updateTableListForRefTable`, nowTabTable) // 更新子表-表格
          } catch (e) {
            console.log(e);
          }
        }
      }
    },
    initSubLinkChange01: _.debounce(function() {
      this.subLinkChange01()
    }, 1200)
  }
}
